import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { IMAGES } from '../data/mock';

export default function PageHero({ eyebrow, title, accent, subtitle, img }) {
  return (
    <section className="relative pt-32 pb-16 md:pt-52 md:pb-32 overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES[img]} alt="" loading="eager" fetchpriority="high" decoding="async" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a]/80 via-[#0a0a0a]/85 to-[#0a0a0a]" />
        <div className="absolute inset-0 bg-[#0a0a0a]/40" />
      </div>
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        {eyebrow && <p className="hx-eyebrow mb-4">{eyebrow}</p>}
        <h1 className="font-display text-5xl md:text-7xl lg:text-8xl leading-[0.95] max-w-4xl">
          {title} {accent && <span className="text-accent">{accent}</span>}
        </h1>
        {subtitle && (
          <p className="text-[var(--hx-muted)] text-lg md:text-xl max-w-2xl mt-6 leading-relaxed">{subtitle}</p>
        )}
        <Link to="/contact" className="hx-btn text-base mt-8">
          Réserver ma séance d'essai <ArrowRight size={18} />
        </Link>
      </div>
    </section>
  );
}
